import { forwardRef, type Ref, type SVGProps } from "react";
const IconRotateClockwiseFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16.443 3.653a.966.966 0 1 1 1.366-1.366l2.63 2.629c.196.197.29.457.282.715a.96.96 0 0 1-.282.719l-2.63 2.629a.966.966 0 0 1-1.366-1.366l1.042-1.042-5.914.018a6.34 6.34 0 0 0-6.322 6.322l-.024 8.137a.966.966 0 1 1-1.932-.006l.024-8.137a8.273 8.273 0 0 1 8.249-8.248l5.864-.017z" />
    <path d="M27.059 12.093c.91 0 1.648.738 1.648 1.648v14.607c0 .91-.738 1.648-1.648 1.648H12.452c-.91 0-1.648-.738-1.648-1.648V13.741c0-.91.738-1.648 1.648-1.648z" />
  </svg>
);
const ForwardRef = forwardRef(IconRotateClockwiseFilledSVG);
ForwardRef.displayName = "IconRotateClockwiseFilled";
export { ForwardRef as IconRotateClockwiseFilled };
